import React from 'react';
import Dollar from '../../assets/Dollar.png';
import Handshake from '../../assets/Handshake.png';
import Smiley from '../../assets/Smiley.png';
import { CustomerSay } from '../../components';
import FeelTrust from '../../components/feelTrust';
import { Layout } from '../../components/page-layout';
import Questions from '../../components/questions';
import ChoosingProduct from './components/choosingProduct';
import PricingTable from './components/pricingTable';
import styled from 'styled-components';

const MainWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
`;

const PerksBar = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
  border-top: 1px solid #e5e7eb;
  padding: 2rem;
  box-sizing: border-box;
  background: #fff;
`;

const Perk = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

const PerkIcon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`;

const PerkText = styled.span`
  color: #374151;
  font-size: 1rem;
`;

export default function PlanPage() {
  return (
    <Layout showCommonFooter={true}>
      <MainWrapper>
        <PricingTable />
        <Questions />
        <CustomerSay />
        <ChoosingProduct />
        <FeelTrust />
        <PerksBar>
          <Perk>
            <PerkIcon src={Smiley} alt="Icon 1" />
            <PerkText>2-Year Warranty</PerkText>
          </Perk>
          <Perk>
            <PerkIcon src={Dollar} alt="Icon 2" />
            <PerkText>30-Day Money-Back Guarantee</PerkText>
          </Perk>
          <Perk>
            <PerkIcon src={Handshake} alt="Icon 3" />
            <PerkText>Lifetime Customer Support</PerkText>
          </Perk>
        </PerksBar>
      </MainWrapper>
    </Layout>
  );
}